import React from "react";

const coreValueIcon = require("assets/img/icons/common/corevalue.png");
const globalReachMap = require("assets/img/home/map.png");
const keyOperationIcons = [
  require("assets/img/icons/common/keyoperation1.png"),
  require("assets/img/icons/common/keyoperation2.png"),
  require("assets/img/icons/common/keyoperation3.png"),
  require("assets/img/icons/common/keyoperation4.png")
];

const keyOperations = [
  {
    icon: keyOperationIcons[0],
    title: ["GLOBAL SOURCING", "& TRADING"],
    description: "Trading critical commodities, strategic advanced materials through our international network and deep market expertise."
  },
  {
    icon: keyOperationIcons[1],
    title: ["EPC", "INFRASTRUCTURE", "& ENERGY"],
    description: "Delivering integrated solutions across AI and telecom networks, industrial engineering and automation, infrastructure, renewable power, and industrial energy through end-to-end engineering, procurement, and project execution."
  },
  {
    icon: keyOperationIcons[2],
    title: ["STRATEGIC", "INVESTMENT"],
    description: "Creating enduring value through strategic investments, project financing, and cross-border capital partnerships, while advancing multigenerational wealth through our Global Heritage Wealth & Family Office Fund."
  },
  {
    icon: keyOperationIcons[3],
    title: ["DIVERSIFIED", "PORTFOLIO"],
    description: "Building and operating across high-growth sectors, including global consumer products, culture and commerce, food and beverage, entertainment, and defense systems."
  }
];

class Whatwefocus extends React.Component {
  render() {
    return (
      <>
        <section className="core-value-section" id="business_page">
          <div className="core-value-inner">
            <div className="core-value-heading">
              <img className="core-value-heading-icon" src={coreValueIcon} alt="" aria-hidden="true" />
              <h2 className="core-value-title">OUR CORE VALUE</h2>
              <p className="core-value-description">
                We connect strategic supply, high-growth markets, and global capital—providing access to critical materials and advanced technologies for infrastructure, AI data centers, and semiconductor development, while creating enduring value through cross-border investment and our Global Heritage Family Office Fund.
              </p>
            </div>
          </div>
        </section>

        <section className="key-operations-section">
          <div className="core-value-inner">
            <div className="key-operations-panel">
              <h3 className="key-operations-title">KEY OPERATIONS</h3>
              <p className="key-operations-subtitle">INTEGRATED CAPABILITIES. GLOBAL REACH. LASTING IMPACT</p>
              <div className="key-operations-grid key-operations-grid--legacy">
                {keyOperations.map((item) => (
                  <article className="key-operation-card" key={item.title.join(" ")}>
                    <div className="key-operation-icon-ring">
                      <img className="key-operation-icon" src={item.icon} alt="" aria-hidden="true" />
                    </div>
                    <h4>
                      {item.title.map((line) => (
                        <span key={line}>{line}</span>
                      ))}
                    </h4>
                    <p>{item.description}</p>
                  </article>
                ))}
              </div>
            </div>
          </div>

          <div className="global-reach-panel">
            <div className="global-reach-copy">
              <h3>GLOBAL REACH</h3>
              <p>Anchored networks across key markets for global connectivity.</p>
            </div>
            <img
              className="global-reach-map"
              src={globalReachMap}
              alt="Global reach map showing HMG networks across USA, Singapore, Vietnam, South Korea, and Japan"
            />
          </div>
        </section>
      </>
    );
  }
}

export default Whatwefocus;
